<script lang="ts">
	import type { PageData } from './$types';
	import LandingPageRouter from '$components/Page/LandingPageRouter.svelte';

	let { data }: { data: PageData } = $props();
</script>

<LandingPageRouter page={data.page} />
